export default "__VITE_ASSET__jbK4QmSs__"